module.exports = __webpack_public_path__ + "fonts/TribalIcons.41415c4.ttf";